import React from "react";
import "./PcaWhyNot.css";

const reasons = [
  {
    title: "Unsold results",
    text: "Cars that didn't meet reserve show where buyers stopped. Most auction sites bury them."
  },
  {
    title: "Multiple platforms",
    text: "Major online auction results, side by side."
  },
  {
    title: "True comps",
    text: "Filter by transmission, mileage, paint, interior, and major options."
  },
  {
    title: "Market direction",
    text: "See if your model is rising or cooling versus past periods."
  },
  {
    title: "Hours back",
    text: "An evening of tabs and spreadsheets becomes a minute."
  }
];

function PcaWhyNot() {
  return (
    <section className="why-not-section" id="why-not">
      <h2 className="why-not__headline">"Can't I just search auction listings myself?"</h2>
      <p className="why-not__subhead">You can. Here's what you'd miss.</p>
      <div className="why-not__grid">
        {reasons.map((reason) => (
          <div className="why-not__card" key={reason.title}>
            <h3 className="why-not__card-title">{reason.title}</h3>
            <p className="why-not__card-text">{reason.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default PcaWhyNot;
